import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IRatingNotification, IUpdateRatingNotification } from './interfaces';

export const checkRatingNotification = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IRatingNotification>(`/notification/rating/list`, config)
    .then((response) => response.data);
};

export const updateRatingNotification = (data: IUpdateRatingNotification) => {
  return instance()
    .post(`/notification/rating/update`, data)
    .then((response) => response.data);
};
